import React, { useEffect, useContext } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import NewAdminForm from "../../components/forms/NewAdminForm";
import { useForm } from "@mantine/form";
import { useToast } from '@chakra-ui/react'
import { AdminContext } from "../../contexts/AdminContext";
import { addAdmin } from "../../services/admin";
import { useMutation } from "react-query";
import { SuccessToast } from "../../components/alert/SuccessToast";

export interface AdminData {
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  role: string
}

export default function NewAdmin() {
  const { admin } = useContext(AdminContext)
  const toast = useToast()

  useEffect(() => {
    document.title = "New Admin";
  }, []);

  const form = useForm({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      role: 'basic'
    },

    validate: {
      firstName: (value) => (
        !value ? 'First name is required' : null
      ),
      lastName: (value) => (
        !value ? 'Last name is required' : null
      ),
      email: (value) => (
        !value ? 'Email is required' :
          !/^\S+@\S+$/.test(value) ? 'Invalid email' : null
      ),
      password: (value) => (
        !value ? 'Password is required' : null
      )
    },
  });

  const mutation = useMutation((data: any) => addAdmin(data, `bearer ${admin.token}`), {
    onError: (error: any) => {
      form.setErrors({
        email: error.response.data.message
      })
    },

    onSuccess: () => {
      form.reset();
      toast({
        title: "Signin success!",
        status: 'success',
        isClosable: true,
        duration: 2000,
        render: () => (
          <SuccessToast message="Admin Added!" />
        )
      })
    },
  })

  const handleNewAdmin = (adminData: AdminData) => {
    mutation.mutate(adminData)
  }

  return (
    <React.Fragment>
      <DashboardLayout>
        <NewAdminForm 
          form={form}
          mutation={mutation}
          handleNewAdmin={handleNewAdmin}
        />
      </DashboardLayout>
    </React.Fragment>
  )
}